import _ from "lodash";
import React, { useReducer, useState, useRef } from "react";
import classes from "./Header.scss";
import {
  SettingsOutlined,
  ChevronLeftOutlined,
  ToddleColored,
} from "@toddle-edu/ds-icons";
import { useI18n } from "Hooks";
import { onAddFirstRow } from "NodeEditor/Utils";
import FullScreenLoader from "UIComponents/FullScreenLoader";
import ACLStore from "lib/aclStore";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import { connect } from "react-redux";
import {
  Button,
  ButtonDisclosure,
  Dropdown,
  DropdownMenu,
  IconButton,
  IconDisclosure,
  Alert,
  Dialog,
  Tooltip,
} from "@toddle-edu/ds-web";
import { disableEditForMapleBearChildOrg } from "Courses/modules/utils";
import { Trans } from "react-i18next";
import { getLabelWithArchivedText } from "Utils";
import { goBackFromChild } from "Administrator/modules/AdministratorModule";
import { goToBack } from "modules/NavigationModule";
import { getIsPreviousAcademicYearSelected } from "modules/CommonSelectors";
import ConditionalWrapper from "Utils/ConditionalWrapper";
import { NODE_TYPE_IB_PYP_CURRICULUM_PROGRAM } from "Constants/stringConstants";
import {
  updateSubjectItem,
  getRootNodes,
} from "MultiLevelNodeEditor/modules/MultiLevelNodeEditorModule";
const getDialogueBoxData = ({
  t,
  type,
  headerLabel,
  plannerElementSetLabel,
  isHeaderArchived,
  currentCurriculumType,
}) => {
  switch (type) {
    case "DRAFT_CONFIRMATION":
      return {
        modalTitle: t("scopeAndSequence:unpublished_changes"),
        modalBody: t("scopeAndSequence:unpublished_changes_msg", {
          subject: headerLabel,
        }),
        confirmText: t("common:retain_changes"),
        cancelText: t("common:discard_changes"),

        name: type,
        variant: "confirm-dialog",
      };
    case "RECONFIGURE":
      return {
        modalTitle: t("scopeAndSequence:reconfigure_module", {
          moduleName: plannerElementSetLabel,
        }),
        modalBody: (
          <div>
            <Trans
              i18nKey={"scopeAndSequence:reconfigure_item_module_warning_msg"}
              tOptions={{ context: isHeaderArchived ? "archived" : null }}
            >
              {{ itemName: headerLabel }}
              {isHeaderArchived ? (
                <span className={classes.archivedText}></span>
              ) : null}
              {{ moduleName: plannerElementSetLabel }}
            </Trans>
            <div className={classes.alertContainer}>
              <Alert
                type="warning"
                message={
                  _.isEqual(
                    currentCurriculumType,
                    NODE_TYPE_IB_PYP_CURRICULUM_PROGRAM
                  )
                    ? t(
                        "scopeAndSequence:reconfigure_module_warning_msg_desc",
                        { moduleName: plannerElementSetLabel }
                      )
                    : t(
                        "scopeAndSequence:reconfigure_other_curriuclum_warning_msg_desc",
                        { moduleName: plannerElementSetLabel }
                      )
                }
              />
            </div>
          </div>
        ),
        confirmText: t("scopeAndSequence:reconfigure"),
        cancelText: t("common:cancel"),
        name: type,
        variant: "delete-dialog",
      };
    case "EDIT_TO_VIEW_CONFIRM":
      return {
        modalTitle: t("common:save_exit_small"),
        modalBody: (
          <div className={classes.saveDraftContainer}>
            <div>{t("scopeAndSequence:exit_from_draft_text_one")}</div>
            {t("scopeAndSequence:exit_from_draft_text_two")}
          </div>
        ),
        confirmText: t("common:okay"),
        cancelText: t("common:cancel"),
        name: type,
        variant: "confirm-dialog",
      };
    default:
      console.error("Other Case");
  }
};
const renderMenuItems = ({
  t,
  plannerElementSetLabel,
  isPreviousAcademicYearSelected,
}) => {
  const disabledTooltipLabel = label =>
    t("schoolSetup:navigate_to_the_current_academic_year_to_edit_with_label", {
      label,
    });
  const MENU_ITEMS = [
    {
      label: t("scopeAndSequence:reconfigure_module", {
        moduleName: plannerElementSetLabel,
      }),
      key: "RECONFIGURE",
      disabled: isPreviousAcademicYearSelected,
      disabledTooltip: disabledTooltipLabel(
        t("scopeAndSequence:reconfigure_module", {
          moduleName: plannerElementSetLabel,
        })
      ),
      permission: "AdminPortal:SnSReconfigure",
    },
    {
      label: t("scopeAndSequence:rename_hierarchy_levels"),
      key: "EDIT_HIERARCHY",
      disabled: isPreviousAcademicYearSelected,
      disabledTooltip: disabledTooltipLabel(
        t("scopeAndSequence:rename_hierarchy_levels")
      ),
    },
    {
      label: t("scopeAndSequence:append_module", {
        moduleName: plannerElementSetLabel,
      }),
      key: "APPEND",
      disabled: isPreviousAcademicYearSelected,
      disabledTooltip: disabledTooltipLabel(
        t("scopeAndSequence:append_module", {
          moduleName: plannerElementSetLabel,
        })
      ),
      permission: "AdminPortal:SnSAppendBulkUpload",
    },
  ];

  return _.filter(MENU_ITEMS, item => {
    if (_.has(item, "permission")) {
      return ACLStore.can(item.permission);
    }
    return true;
  });
};

const renderMenuItemsMemoized = _.memoize(
  params => renderMenuItems(params),
  params => JSON.stringify(params)
);
const Header = props => {
  const { t } = useI18n(["common", "scopeAndSequence"]);
  const {
    subjects = [],
    mode,
    onChangeMode,
    goBackFromChild,
    goToBack,
    headerLabel,
    description,
    draftId,
    createMultiLevelNodesDraft,
    deleteMultiLevelNodesDraft,
    subjectId,
    nodeType,
    nodes,
    rootNodes,
    inputForMultiLevelNodeQuery,
    nodesObjMap,
    setNodes,
    currentEditorConfig,
    goToRelativeRoute,
    updateSnsSettingsAction,
    isSetPreview,
    onBackClick,
    onClickChoose,
    publishMultiLevelNodeDraft,
    userId,
    rootNodeId,
    showEditButton,
    setToastMsg,
    customOnSettingsItemClick,
    isEditButtonDisabled,
    disableToolTipMsg,
    plannerElementSetConfig,
    addRootNode,
    plannerElementParentNode,
    nodesMap,
    plannerElementSetLabel,
    isHeaderArchived = false,
    loginActiveTab,
    showTitleAsDropdown,
    isPreviousAcademicYearSelected,
    currentCurriculumType,
    rootNode,
    updateSubjectItem,
    testId,
    shouldBypassDisable = false,
  } = props;

  const componentTestId = testId ? `${testId}-header` : undefined;

  const isAdminPortal = loginActiveTab == "admin";

  const [isLoading, setIsLoading] = useState(false);
  const dropDownActionRef = useRef(null);

  const reducer = (prevState, action) => {
    if (action != "CLOSE_DIALOGUE") {
      return getDialogueBoxData({
        t,
        type: action,
        headerLabel,
        plannerElementSetLabel,
        nodeType,
        isHeaderArchived,
        currentCurriculumType,
      });
    } else {
      return {};
    }
  };
  //we are using useReducer to manage dialogueBoxes state and data
  const [currentDialogueBoxData, dispatchDialogue] = useReducer(reducer, {});

  //This function checks if there are any errors related to the editor.
  const checkIsValid = () => {
    let isValid = true;
    const errorCheckFields = _.get(currentEditorConfig, "errorCheckFields", []);
    let nodeToScrollTo;
    const newNodes = { ...nodesObjMap };
    _.forOwn(newNodes, (value, key) => {
      if (value.parentId) {
        for (const field of errorCheckFields) {
          const currentFieldValue = value[field];
          if (_.isEmpty(currentFieldValue) && value.depth != 0) {
            newNodes[key] = { ...value, isError: true };
            isValid = false;
            if (!nodeToScrollTo) nodeToScrollTo = key;
            break;
          }
          newNodes[key] = { ...value, isError: false };
        }
      }
    });
    if (isValid) {
      return true;
    } else {
      setNodes(newNodes);
      const node = document.getElementById(nodeToScrollTo);
      if (node) node.scrollIntoView({ block: "center" });
      return false;
    }
  };

  const getRootNodesForMutation = () =>
    addRootNode // rootNodes are different for planner elements and benchmark
      ? _.get(nodesMap, [rootNodeId, "children"], [])
      : rootNodes;

  const getCreateMultiLevelNodesDraftInput = () => {
    return {
      nodeType: nodeType,
      nodes,
      rootNodes: getRootNodesForMutation(),
      subjectId,
    };
  };

  const toggleMode = async () => {
    if (mode == "view") {
      if (!_.isEmpty(draftId)) {
        //if there is any draftId present, we show the confirmation dialogueBox
        dispatchDialogue("DRAFT_CONFIRMATION");
      } else {
        //if the subject dont have draft, we create a new draft for this subject
        setIsLoading(true);

        const result = await createMultiLevelNodesDraft({
          input: getCreateMultiLevelNodesDraftInput(),
          inputForMultiLevelNodeQuery,
        });
        setIsLoading(false);
        if (result) {
          //if the draft creation is successful we switch into editing mode
          onChangeMode();
        }
      }
    } else if (mode == "edit") {
      dispatchDialogue("EDIT_TO_VIEW_CONFIRM");
    }
  };

  const showSettingsButton =
    !isSetPreview &&
    showEditButton &&
    !disableEditForMapleBearChildOrg({
      shouldBypassDisable: shouldBypassDisable,
    }) &&
    mode !== "edit";

  const btnText =
    mode === "view" ? t("common:edit") : t("common:save_as_draft");

  const disabledToolTipMessage = disableToolTipMsg
    ? disableToolTipMsg
    : t(
        "schoolSetup:navigate_to_the_current_academic_year_to_edit_with_label",
        { label: btnText }
      );

  const goBack = () => {
    if (isSetPreview) {
      onBackClick();
    } else {
      if (onBackClick) onBackClick();
      else {
        if (isAdminPortal) {
          goBackFromChild({
            hasChild: true,
            isClickedFromHomeScreen: false,
          });
        } else {
          goToBack();
        }
      }
    }
  };

  const closeDialogueBox = () => {
    dispatchDialogue("CLOSE_DIALOGUE");
  };

  const onClickButton1 = async () => {
    const { name } = currentDialogueBoxData;
    switch (name) {
      case "DRAFT_CONFIRMATION":
        {
          //delete the existing draft for this subject and create a new draft for this subject
          const input = { draftId };
          setIsLoading(true);
          const isDeleteDraftSuccess = await deleteMultiLevelNodesDraft(input);
          if (isDeleteDraftSuccess) {
            const inputForCreateDraft = getCreateMultiLevelNodesDraftInput();
            // Node types which have addRootNode true have an addition subject node appended
            // PYP SNS has addRootNode false as it has subject node already. If 1 node present then it is only subject node so nodes are empty
            // Other SNS has addRootNode true as it doesn't have subject node. Here if nodes are 0 then its empty
            const emptyNodesCount = addRootNode ? 1 : 2;
            const isNodeDataEmpty = _.size(nodes) < emptyNodesCount; // Size 0 or 1 means there are no nodes
            if (isNodeDataEmpty) {
              // create one dummy node as a draft
              const newNodes = onAddFirstRow({
                rootNodeId,
                nodes: nodesMap,
                setNodes,
                userId,
                insertRootNode: !addRootNode, // Not adding rootNode for Planner elements just for the draft mutation
              });
              inputForCreateDraft["nodes"] = newNodes;
              if (addRootNode)
                // For planner elements rootNodes are the depth 1 nodes. So sending the newly created depth 1 node for rootNodes
                inputForCreateDraft["rootNodes"] = [_.head(newNodes)?.id];
            }
            const result = await createMultiLevelNodesDraft({
              input: inputForCreateDraft,
              inputForMultiLevelNodeQuery,
            });
            setIsLoading(false);
            if (result) {
              onChangeMode();
            }
          }
        }
        break;
    }
    closeDialogueBox();
  };

  const onSettingsItemClick = ({ key }) => {
    dropDownActionRef.current?.focus();
    if (key === "RECONFIGURE") {
      dispatchDialogue(key);
      return;
    }

    updateSnsSettingsAction(key); // updates redux with snsSettingsAction for showUpload and showEditLevels pages
    if (customOnSettingsItemClick) {
      // in case of planner elements this function is given to handle menu item navigation
      customOnSettingsItemClick({ action: key });
    } else {
      goToRelativeRoute({ route: "../" });
    }
  };

  const onClickButton2 = async () => {
    const { name } = currentDialogueBoxData;
    switch (name) {
      case "DRAFT_CONFIRMATION":
        {
          onChangeMode();
        }
        break;
      case "RECONFIGURE":
        //open the reconfigure frame that will render in MultiNodeLevelEditor.js
        {
          updateSnsSettingsAction(name);
          if (customOnSettingsItemClick) {
            customOnSettingsItemClick({ action: name });
          } else {
            goToRelativeRoute({ route: "../" });
          }
        }
        break;
      case "EDIT_TO_VIEW_CONFIRM":
        {
          //from edit to view mode
          onChangeMode();
        }
        break;
      default:
        console.error("other case");
    }
    closeDialogueBox();
  };

  const onClickPublish = async () => {
    const isValid = checkIsValid();
    if (isValid) {
      setIsLoading(true);
      const isDraftPublished = await publishMultiLevelNodeDraft({
        draftId,
        inputForMultiLevelNodeQuery,
        plannerElementSetId: plannerElementSetConfig.id,
      });

      if (isDraftPublished) {
        onChangeMode("view");
      }
      setIsLoading(false);
    } else {
      setToastMsg({ msg: "toastMsgs:sns_errors_on_publish" });
    }
  };

  const onSubjectChange = data => {
    const { key: subjectId } = data;

    const subjectNode = _.find(rootNode, subject => {
      return subject.id == subjectId;
    });
    updateSubjectItem(subjectNode);
    goToRelativeRoute({
      route: `../../scopeandsequence/${subjectId}?subjectId=${subjectId}`,
      type: "replace",
    });
  };

  const subjectOverlayOptions = _.map(
    _.filter(subjects, i => !_.isNull(_.get(i, "benchmarkRootNode"))),
    subject => {
      return {
        key: subject.id,
        label: subject.name,
        isArchived: subject.isArchived,
      };
    }
  );

  return (
    <div className={classes.container}>
      <div className={classes.containerInner}>
        <div className={classes.leftContent}>
          <div className={classes.goBackDiv}>
            <div className={classes.chevronIcon}>
              <IconButton
                variant={"plain"}
                icon={<ChevronLeftOutlined />}
                onClick={goBack}
                testId={`${componentTestId}-back`}
              />
            </div>
            <div className={classes.toddleIcon}>
              <ToddleColored size="medium" />
            </div>
          </div>
          <div className={classes.headings}>
            {!_.isEmpty(subjectOverlayOptions) && showTitleAsDropdown ? (
              <Dropdown
                overlayClassName={classes.dropdownOverlay}
                overlay={
                  <DropdownMenu
                    options={subjectOverlayOptions}
                    onClick={onSubjectChange}
                    testId={`${componentTestId}-subjectChange`}
                  />
                }
              >
                <ButtonDisclosure
                  className={classes.dropdownLabel}
                  size={"medium"}
                  variant={"plain"}
                  testId={`${componentTestId}-`}
                >
                  <div className={classes.dropdownText}>
                    {getLabelWithArchivedText({
                      t,
                      label:
                        headerLabel ??
                        _.get(
                          _.filter(subjects, i => _.isEqual(i.id, subjectId)),
                          "name"
                        ),
                      isArchived: isHeaderArchived,
                    })}
                  </div>
                </ButtonDisclosure>
              </Dropdown>
            ) : (
              <div className={classes.heading}>
                {getLabelWithArchivedText({
                  t,
                  label: headerLabel,
                  isArchived: isHeaderArchived,
                })}
              </div>
            )}
            <div className={classes.subHeading}>{description}</div>
          </div>
        </div>
        <div className={classes.rightContent}>
          {showSettingsButton && (
            <>
              <div
                id={"COACHMARKS_SCOPE_SEQUENCE_VIEWER_PREFERENCES_BUTTON"}
                className={classes.preferencesContainer}
              >
                <Dropdown
                  overlay={
                    <DropdownMenu
                      options={renderMenuItemsMemoized({
                        t,
                        plannerElementSetLabel,
                        isPreviousAcademicYearSelected,
                      })}
                      onClick={onSettingsItemClick}
                    />
                  }
                  disabled={isEditButtonDisabled}
                >
                  <IconDisclosure
                    size={"large"}
                    icon={<SettingsOutlined />}
                    variant="plain"
                    ref={dropDownActionRef}
                  />
                </Dropdown>
              </div>

              <ConditionalWrapper
                condition={
                  isEditButtonDisabled || isPreviousAcademicYearSelected
                }
                type={"wrapperAsElement"}
                wrapper={
                  <Tooltip
                    overlayInnerStyle={{ maxWidth: "160px" }}
                    tooltip={disabledToolTipMessage}
                    position={"bottomLeft"}
                  />
                }
              >
                <div
                  id={
                    mode === "view"
                      ? "COACHMARKS_SCOPE_SEQUENCE_VIEWER_EDIT_BUTTON"
                      : ""
                  }
                >
                  <Button
                    onClick={toggleMode}
                    disabled={
                      isEditButtonDisabled || isPreviousAcademicYearSelected
                    }
                  >
                    {btnText}
                  </Button>
                </div>
              </ConditionalWrapper>
            </>
          )}
          {isSetPreview && (
            <Button onClick={onClickChoose}>{t("common:choose")}</Button>
          )}
          {!isSetPreview && mode === "edit" && showEditButton && (
            <div id={"COACHMARKS_SCOPE_SEQUENCE_EDITOR_PUBLISH_BUTTON"}>
              <Button variant="progressive" onClick={onClickPublish}>
                {t("common:save_with_label", {
                  label: t("common:lowercase", {
                    text: t("common:and_label") + t("common:publish"),
                  }),
                })}
              </Button>
            </div>
          )}
        </div>
      </div>
      {!_.isEmpty(currentDialogueBoxData) && (
        <Dialog
          onClose={closeDialogueBox}
          title={currentDialogueBoxData.modalTitle}
          message={currentDialogueBoxData.modalBody}
          variant={currentDialogueBoxData.variant}
          onButtonOneClick={onClickButton1}
          onButtonTwoClick={onClickButton2}
          buttonOneText={currentDialogueBoxData.cancelText}
          buttonTwoText={currentDialogueBoxData.confirmText}
        />
      )}
      {isLoading && <FullScreenLoader />}
    </div>
  );
};
const getRootNodesMemoize = _.memoize(
  params => getRootNodes(params),
  params => JSON.stringify(params)
);
const mapActionCreators = {
  setToastMsg,
  goBackFromChild,
  goToBack,
  updateSubjectItem,
};

const mapStateToProps = (state, ownProps) => {
  const { subjects } = ownProps;
  const loginActiveTab = state.login.activeTab;
  const isPreviousAcademicYearSelected = getIsPreviousAcademicYearSelected(
    state
  );
  const currentCurriculumType = _.get(
    state,
    "platform.currentCurriculumProgram.nodeInterfaceType"
  );
  const rootNode = getRootNodesMemoize({ subjects });
  return {
    loginActiveTab,
    isPreviousAcademicYearSelected,
    currentCurriculumType,
    rootNode,
  };
};

export default connect(mapStateToProps, mapActionCreators)(Header);
